import { css, ThemeProvider } from '@emotion/react';
import PropTypes from 'prop-types';
import { IconButton as CorgixIconButton } from '@veeva/corgix/button';

const propTypes = {
    css: PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.array]),
    disabled: PropTypes.bool,
    icon: PropTypes.oneOfType([
        PropTypes.object,
        PropTypes.array,
        PropTypes.string,
        PropTypes.element,
    ]),
    onClick: PropTypes.func,
};

const IconButton = (iconButtonProps) => {
    const iconButtonCSS = ({
        linkBlue,
        buttonHeight,
        buttonIconBackgroundColorFocus,
        buttonIconBackgroundColorHover,
        buttonIconBackgroundColorActive,
    }) => css`
        border-radius: calc(${buttonHeight} / 2);
        padding: 0;
        flex-shrink: 0;
        &:not([disabled]) {
            &:focus-visible {
                outline: 2px solid ${linkBlue};
                background-color: ${buttonIconBackgroundColorFocus};
            }

            &:hover {
                background-color: ${buttonIconBackgroundColorHover};
            }

            &:active {
                background-color: ${buttonIconBackgroundColorActive};
            }
        }
    `;

    return (
        <ThemeProvider
            theme={(theme) => ({
                ...theme,
                buttonIconColorFocus: theme.black,
                buttonIconColorActive: theme.black,
                buttonIconColorHover: theme.black,
            })}
        >
            <CorgixIconButton
                css={iconButtonCSS}
                // eslint-disable-next-line react/jsx-props-no-spreading
                {...iconButtonProps}
            />
        </ThemeProvider>
    );
};

IconButton.propTypes = propTypes;
export default IconButton;
